import { I06SEPHYD_State } from '@batical/types/src'

const I06SEPHYD: I06SEPHYD_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  in_index_puissanceOrQ: 0,
  in_puissQ: 200.0,
  in_deltaT: 23.0,
  in_debit: 20.0,
  in_velocite: 0.5,
  res_minV: 0.5,
  res_maxV: 1.5,
  res_maxVCalcule: 1.5,
  res_DN1: '',
  res_DN3: '',
  res_distanceGrande: 0,
  res_distancePetite: 0,
  res_vitesseBouteille: 0,
  mode: 'none',
  calcul_code: 'I06SEPHYD'
}

export default I06SEPHYD
